import React, { Component } from 'react';
import {
    Modal, Form, Row, Col, Input,
} from 'antd';

const FormItem = Form.Item;
// const Option = Select.Option;

class UnwrappedAddPartnerLocationModal extends Component {
    render() {
        const {
            visible, onCancel, onCreate, form, confirmLoading,
        } = this.props;

        const { getFieldDecorator } = form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 15 },
            },
        };

        return (
            <Modal
                visible={visible}
                width="50%"
                title="Add a location"
                style={{ textAlign: 'center', fontSize: '1.2em', top: 20 }}
                okText="Submit"
                confirmLoading={confirmLoading}
                onCancel={onCancel}
                onOk={onCreate}
            >

                <Form layout="vertical">
                    <div style={{ height: '580px', overflow: 'auto' }}>
                        <FormItem
                            {...formItemLayout}
                            label="Location Name"
                        >
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: 'Please input name of the partner location!' }],
                            })(
                                <Input />,
                            )}
                        </FormItem>
                        {/* <FormItem
                            { ...formItemLayout }
                            label="Logistic Type"
                        >
                            {getFieldDecorator('logistics_type', {
                                rules: [{ required: false, message: 'Please select the type of partner!' }],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            { ...formItemLayout }
                            label="Pickup Frequency"
                        >
                            {getFieldDecorator('pickup_frequency', {
                                rules: [{ required: false, message: 'Please select the type of partner!' }],
                            })(
                                <InputNumber min={0} />
                            )}
                        </FormItem>
                        <FormItem
                            { ...formItemLayout }
                            label="PickUp Date"
                        >
                            {getFieldDecorator('pickup_dates', {
                                rules: [{ required: false, message: 'Please Input start date of partner!' }],
                            })(
                                <DatePicker style={{ width: '100%' }} />
                            )}
                        </FormItem>
                        <FormItem
                            { ...formItemLayout }
                            label="PickUp Days"
                        >
                            {getFieldDecorator('pickup_days', {
                                rules: [{ required: true, message: 'Please select the type of partner!' }],
                            })(
                                <Select showSearch
                                mode="combobox"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Option value="MONDAY">MONDAY</Option>
                                    <Option value="TUESDAY">TUESDAY</Option>
                                    <Option value="WEDNESDAY">WEDNESDAY</Option>
                                    <Option value="THURSDAY">THURSDAY</Option>
                                    <Option value="FRIDAY">FRIDAY</Option>
                                    <Option value="SATURDAY">SATURDAY</Option>
                                    <Option value="SUNDAY">SUNDAY</Option>
                                </Select>
                            )}
                        </FormItem> */}
                        {/*
                        <FormItem
                            { ...formItemLayout }
                            label="Payment Cycle"
                        >
                            {getFieldDecorator('payment_cycle', {
                                rules: [{ required: true, message: 'Please Input payment cycle!' }],
                            })(
                                <InputNumber min= {0} style={{width:'100%'}} />
                            )}
                        </FormItem>

                        <FormItem
                            { ...formItemLayout }
                            label="Payment Schedule Day"
                        >
                            {getFieldDecorator('payment_schedule_day', {
                                rules: [{ required: true, message: 'Day Required!' }],
                            })(
                                <Select showSearch
                                mode="combobox"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                <Option value="Monday">Monday</Option>
                                <Option value="Tuesday">Tuesday</Option>
                                <Option value="Wednesday">Wednesday</Option>
                                <Option value="Thursday">Thursday</Option>
                                <Option value="Friday">Friday</Option>
                                <Option value="Saturday">Saturday</Option>
                                <Option value="Sunday">Sunday</Option>
                            </Select>
                            )}
                        </FormItem>
                        <hr/> */}
                        <div>
                            <p className="lead">Enter Location Details</p>
                        </div>
                        <FormItem
                            {...formItemLayout}
                            label="Name"
                        >

                            {getFieldDecorator('address_name', {
                                rules: [{ required: true, message: 'Please input Name of Partner Location!' }],
                            })(
                                <Input />,
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Address"
                        >

                            {getFieldDecorator('line_1', {
                                rules: [{ required: true, message: 'Please input address of Partner!' }],
                            })(
                                <Input />,
                            )}
                        </FormItem>
                        <Row>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="City"
                                >
                                    {getFieldDecorator('city', {
                                        rules: [{ required: true, message: 'Please enter city of Partner!' }],
                                    })(
                                        <Input />,
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="State"
                                >
                                    {getFieldDecorator('state', {
                                        rules: [{ required: true, message: 'Please enter state!' }],
                                    })(
                                        <Input style={{ width: '100%' }} />,
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="Pincode"
                                >
                                    {getFieldDecorator('pin_code', {
                                        rules: [{ required: true, message: 'Please enter pincode! ' }],
                                    })(
                                        <Input />,
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="Country"
                                >
                                    {getFieldDecorator('country', {
                                        rules: [{ required: true, message: 'Please enter country!' }],
                                    })(
                                        <Input style={{ width: '100%' }} />,
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <hr />
                        <div>
                            <p className="lead">Enter Contact Details</p>
                        </div>
                        <FormItem
                            {...formItemLayout}
                            label="Name"
                        >
                            {getFieldDecorator('contact_name', {
                                rules: [{ required: true, message: 'Please input name of the contact!' }],
                            })(
                                <Input />,
                            )}
                        </FormItem>
                        <Row>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="Email"
                                >
                                    {getFieldDecorator('email', {
                                        rules: [{ type: 'email', required: true, message: 'Please enter email of Partner!' }],
                                    })(
                                        <Input />,
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="Mobile"
                                >
                                    {getFieldDecorator('mobile_number', {
                                        rules: [{ required: true, message: 'Please input your phone number!' }],
                                    })(
                                        <Input addonBefore="+91" style={{ width: '100%' }} />,
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </div>
                </Form>

            </Modal>
        );
    }
}

const AddPartnerLocationModal = Form.create()(UnwrappedAddPartnerLocationModal);

export default AddPartnerLocationModal;



// WEBPACK FOOTER //
// ./src/component/Partners/AddPartnerLocationModal.js